import { useCallback } from 'react';
import { useGetStreamingAudienceQuery } from '../../../../redux/api/fymAPI';

/** Streaming → Audience (design streaming-sections a1-a3): one month of one source. */
export function useStreamingAudience(input: {
  accountId: number;
  days: number;
  source: string | undefined;
  month: string | undefined;
  skip: boolean;
}) {
  const { accountId, days, source, month, skip } = input;
  const read = useGetStreamingAudienceQuery({ accountId, days, source, month }, { skip });
  const { refetch } = read;
  const retry = useCallback(() => {
    refetch().catch(console.error);
  }, [refetch]);
  return { data: read.data, isLoading: read.isLoading, error: read.error, retry };
}
